import React from 'react';
import { useNavigate } from 'react-router-dom';

import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';

import oktaAuth from '@/config/oktaConfig';
import loadDayJsPlugins from '@/utils/loadDayjsPlugins.ts';
import AppRoutes from '@/routes/AppRoutes';

import './App.css';

loadDayJsPlugins();

const App: React.FC = () => {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <AppRoutes />
    </Security>
  );
};

export default App;
